/*** IMPORTS FROM imports-loader ***/
var define = false;

(function($, window, document, undefined) {
	$(window).setBreakpoints({
		// array of widths in pixels where breakpoints should be triggered
		breakpoints: [
			320,
			480,
			720,
			1024,
			1280
		]
	});
})(jQuery, window, document);
